module.exports = __webpack_public_path__ + "img/barcode-black.a99d8821.svg";